module.exports = __webpack_public_path__ + "img/screenshot001.9deffe9a.png";